import { render, staticRenderFns } from "./ProfileOverviewTab.vue?vue&type=template&id=7a76f7c8&"
import script from "./ProfileOverviewTab.vue?vue&type=script&lang=js&"
export * from "./ProfileOverviewTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports